export default __webpack_public_path__ + "static/media/ies_PaulinaVillaloboz.3ced57d8.png";